import React, { useEffect, useState, useRef, useMemo } from "react";
import counter1 from '../../assets/img/counter1.png';
import counter2 from '../../assets/img/counter2.png';
import counter3 from '../../assets/img/counter3.png';
import counter4 from '../../assets/img/counter4.png';
import './Counter.css';

const Counter = () => {
  const counters = useMemo(
    () => [
      { image: counter1, number: 30, description: 'Leading the market' },
      { image: counter2, number: 500, description: 'Members worldwide' },
      { image: counter3, number: 100, description: 'Satisfied clients' },
      { image: counter4, number: 25, description: 'Lines of Business' }
    ],
    []
  );

  const duration = 2000;
  const [counts, setCounts] = useState(Array(counters.length).fill(0));
  const ref = useRef(null);
  const observerRef = useRef(null);

  useEffect(() => {
    observerRef.current = new IntersectionObserver(entries => {
      if (entries[0].isIntersecting) {
        const startTime = Date.now();
        const interval = setInterval(() => {
          const elapsed = Date.now() - startTime;
          if (elapsed >= duration) {
            clearInterval(interval);
            setCounts(counters.map(({ number }) => number));
          } else {
            setCounts(counters.map(({ number }) => Math.min(Math.floor((number * elapsed) / duration), number)));
          }
        }, 50);
      }
    });

    if (ref.current) observerRef.current.observe(ref.current);

    return () => {
      if (observerRef.current) observerRef.current.disconnect();
    };
  }, [counters]);

  return (
    <div className="my-5" ref={ref} style={{background:'#1e3342',position:'relative',zIndex:'5'}} id='counter'>
      <div className="counter_title pt-5">
        <div className="container">
          <div className="row d-flex flex-column align-items-center">
            <h2>
              Why choose <span className="fw-bold pb-4" style={{color:'#E0C460'}}>OrbiNexum?</span>
            </h2>
            <div className="inner_container pb-4">
              {counters.map((slide, index) => (
                <div className="counter_content" key={index}>
                  <img className="icon-img" src={slide.image} alt="" loading="lazy"/>
                  <div className="d-flex flex-row align-items-center">
                    <p className="number">{counts[index]}
                      <span>+</span>
                    </p>
                  </div>
                  <div className="counter-desc">
                    <p>{slide.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Counter;
